import * as React from 'react';
import { TextField } from '@mui/material';
import { useActiveStepContext } from '../hooks/use-active-step-context';
import {
  getContainerStyles,
  helperTextStyles,
  inputStyles,
  labelStyles,
} from '../styles/add-action-text-field';

export const AddActionTextField = ({
  InputProps = {},
  InputLabelProps = {},
  FormHelperTextProps = {},
  sx = {},
  actionStyle = {},
  ...props
}) => {
  const activeStepContext = useActiveStepContext();
  const mergedInputLabelSx = {
    ...labelStyles,
    ...(InputLabelProps?.sx || {}),
  };
  const mergedInputSx = {
    ...inputStyles,
    ...(InputProps?.sx || {}),
  };
  const mergedHelperTextSx = {
    ...helperTextStyles,
    ...(FormHelperTextProps?.sx || {}),
  };
  const containerStyles = {
    ...sx,
    ...getContainerStyles(
      activeStepContext?.actionStyle
        ? activeStepContext?.actionStyle?.color
        : actionStyle.color
    ),
  };
  return (
    <TextField
      fullWidth
      FormHelperTextProps={{
        ...FormHelperTextProps,
        sx: mergedHelperTextSx,
      }}
      InputProps={{
        ...InputProps,
        fullWidth: true,
        disableUnderline: true,
        sx: mergedInputSx,
      }}
      InputLabelProps={{
        ...InputLabelProps,
        disableAnimation: true,
        shrink: false,
        sx: mergedInputLabelSx,
      }}
      sx={containerStyles}
      variant="standard"
      {...props}
    />
  );
};
